import { Component } from '@angular/core';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { Router } from '@angular/router';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { AllHughesNetUsers } from '../../../../models';
import * as moment from 'moment-mini';
import { AimsCommonTableFilterType, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { MainGridService } from 'src/app/components/maingrid/main-grid.service';

const MAX_MACS_ALLOWED: number = 5;

@Component({
  selector: 'manage-users',
  templateUrl: './manageUsers.component.html',
  providers: [MainGridService],
})
export class ManageUsersComponent {

  constructor(private transferHttp: TransferHttpService,
    private router: Router,
    public permissions: PermissionsService,
    public mainGridService: MainGridService<any>) { }

  //***************************
  // Variables
  //***************************
  user = this.transferHttp.getCache('user');
  today = new Date();


  //Dropdown Values
  hughesNetUsers = this.transferHttp.getHot('IT/GetAllHughesNetUsers');
  hughesNetUserTypes = this.transferHttp.getHot('IT/GetHughesNetUserTypes');
  employees = this.transferHttp.getCache(CacheItem.allEmployees);

  //Spinner
  spinnerText: string = "Loading...";

  public hnUsers: Observable<any> = this.mainGridService.getAll(
    'IT/GetAllHughesNetUsers',
    'It/SaveHughesNetUser',
    'It/DeleteHughesNetUser');

  // AimsCommonTable setup
  tablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: true,
    export: false
  };
  header: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', editable: false, filter: false },
    { key: 'lastName', label: 'Last Name', type: 'string', editable: true, validatorOrOpts: [Validators.required ] },
    { key: 'firstName', label: 'First Name', type: 'string', editable: true, validatorOrOpts: [Validators.required ] },
    { key: 'userComments', label: 'Comment', type: 'string', editable: true, },
    { key: 'maxEffectiveDate', label: 'Max Date', type: 'date', editable: true, },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN, filterType: AimsCommonTableFilterType.BOOLEAN, width: 60 },
  ];
  addRowInitialObject = {
    lastName: "",
    firstName: "",
    userComments: "",
    maxEffectiveDate: null,
    active: true

  }

  //***************************
  // Methods
  //***************************

  public handleRowAdd(update: TableRowUpdate): void {
    const user = update.newRow as HughesNetUser;
    const addUser = new HughesNetUser();
    addUser.lastName = user.lastName;
    addUser.firstName = user.firstName;
    addUser.userComments = user.userComments;
    addUser.active = user.active == true;
    addUser.maxEffectiveDate = user.maxEffectiveDate;
    this.mainGridService.add(addUser).subscribe(update.handleSubscribe())
  }

  public handleRowDelete(deleted: TableRowDelete) {
    const row = deleted.row as AllHughesNetUsers;
    this.mainGridService.delete(row.hughesNetUserId, 'hughesNetUserId', deleted.index)
      .subscribe(deleted.handleSubscribe());
  }

  public handleRowUpdate(update: TableRowUpdate): void {
    this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe());
  }

  public colorRows(context) {
    let today = moment();
    if ((context.element.active == false || (context.element.maxEffectiveDate != null && moment(context.element.maxEffectiveDate).isBefore(today, 'day')))) {
      return { 'inactive-user': true };
    }
  }

  //***************************
  // Init
  //***************************
  ngOnInit(): void { }

}

export class HughesNetUser extends AllHughesNetUsers {
  constructor() {
    super();
    this.hughesNetUserId = 0;
    this.lastName = null;
    this.firstName = null;
    this.middleInitial = null;
    this.active = true;
    this.userTypeId = null;
    this.maxEffectiveDate = null;
    this.employeeId = null;
    this.fullName = null;
  }

}
